/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { NegozioTransazioniSelectDTO } from '../model/negozio-transazioni-select-dto';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTransazioneVoucherBackofficeListItemDTO } from '../model/paged-model-transazione-voucher-backoffice-list-item-dto';
// @ts-ignore
import { TransazioneVoucherArticoloErrataCorrigeForm } from '../model/transazione-voucher-articolo-errata-corrige-form';
// @ts-ignore
import { TransazioneVoucherBackofficeListFilter } from '../model/transazione-voucher-backoffice-list-filter';
// @ts-ignore
import { TransazioneVoucherErrataCorrigeForm } from '../model/transazione-voucher-errata-corrige-form';
// @ts-ignore
import { VoucherArticoloRigaBackofficeDTO } from '../model/voucher-articolo-riga-backoffice-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    GestioneErrataCorrigeTransazioniVoucherServiceInterface,
    ErratacorrigeArticoloTransazioneRequestParams,
    ErratacorrigeTransazioneRequestParams,
    ListArticoliVoucherBackofficeRequestParams,
    ListNegoziTransazioniBackofficeRequestParams,
    ListTransazioniBackofficeRequestParams
} from './gestione-errata-corrige-transazioni-voucher.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class GestioneErrataCorrigeTransazioniVoucherService extends BaseService implements GestioneErrataCorrigeTransazioniVoucherServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Errata-corrige di un consumo articolo (voucher cedole).
     * Annulla la transazione articolo originale (PRENOTAZIONE/REGOLARE), riporta l\&#39;istanza articolo allo stato precedente e riapre il voucher SEMPRE a DA_CONSUMARE (mai CONSUMATO→PARZIALMENTE_CONSUMATO). Richiede la version dell\&#39;istanza articolo. SUPERADMIN/OP_COMUNE scopati al comune del bando.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/transazioni/articolo-erratacorrige
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public erratacorrigeArticoloTransazione(requestParameters: ErratacorrigeArticoloTransazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public erratacorrigeArticoloTransazione(requestParameters: ErratacorrigeArticoloTransazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public erratacorrigeArticoloTransazione(requestParameters: ErratacorrigeArticoloTransazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public erratacorrigeArticoloTransazione(requestParameters: ErratacorrigeArticoloTransazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling erratacorrigeArticoloTransazione.');
        }
        const transazioneVoucherArticoloErrataCorrigeForm = requestParameters?.transazioneVoucherArticoloErrataCorrigeForm;
        if (transazioneVoucherArticoloErrataCorrigeForm === null || transazioneVoucherArticoloErrataCorrigeForm === undefined) {
            throw new Error('Required parameter transazioneVoucherArticoloErrataCorrigeForm was null or undefined when calling erratacorrigeArticoloTransazione.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/transazioni/articolo-erratacorrige`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: transazioneVoucherArticoloErrataCorrigeForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Errata-corrige di una transazione voucher.
     * Annulla la transazione originale (obbligatoria), ripristina il residuo del voucher (invariante ≤ valore totale), riporta il voucher a DA_CONSUMARE e crea la nuova ERRATA_CORRIGE (valore &#x3D; valore scontrino cappato al residuo). Richiede la version del voucher. SUPERADMIN/OP_COMUNE scopati al comune del bando.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/transazioni/erratacorrige
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public erratacorrigeTransazione(requestParameters: ErratacorrigeTransazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public erratacorrigeTransazione(requestParameters: ErratacorrigeTransazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public erratacorrigeTransazione(requestParameters: ErratacorrigeTransazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public erratacorrigeTransazione(requestParameters: ErratacorrigeTransazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling erratacorrigeTransazione.');
        }
        const transazioneVoucherErrataCorrigeForm = requestParameters?.transazioneVoucherErrataCorrigeForm;
        if (transazioneVoucherErrataCorrigeForm === null || transazioneVoucherErrataCorrigeForm === undefined) {
            throw new Error('Required parameter transazioneVoucherErrataCorrigeForm was null or undefined when calling erratacorrigeTransazione.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/transazioni/erratacorrige`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: transazioneVoucherErrataCorrigeForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elenca gli articoli di un voucher cedole (input dell\&#39;errata-corrige articolo).
     * Riga-per-libro di un voucher cedole: id_articolo_pratica, version_articolo (la @Version dell\&#39;istanza ArticoloPratica, distinta da version_voucher), titolo, valore, stato e id_transazione (ultima transazione di consumo attiva correlata all\&#39;istanza) — gli input del form articolo-erratacorrige senza un GET aggiuntivo. Scope per-comune via checkTipoPratica (SUPERADMIN bypassa, OP_COMUNE fuori-comune → 403); codice fuori dal bando → lista vuota. id_transazione è null per i libri consumati prima dell\&#39;introduzione della correlazione (dialog degradato).
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/transazioni/voucher/{codice}/articoli
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listArticoliVoucherBackoffice(requestParameters: ListArticoliVoucherBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<VoucherArticoloRigaBackofficeDTO>>;
    public listArticoliVoucherBackoffice(requestParameters: ListArticoliVoucherBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<VoucherArticoloRigaBackofficeDTO>>>;
    public listArticoliVoucherBackoffice(requestParameters: ListArticoliVoucherBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<VoucherArticoloRigaBackofficeDTO>>>;
    public listArticoliVoucherBackoffice(requestParameters: ListArticoliVoucherBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listArticoliVoucherBackoffice.');
        }
        const codice = requestParameters?.codice;
        if (codice === null || codice === undefined) {
            throw new Error('Required parameter codice was null or undefined when calling listArticoliVoucherBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/transazioni/voucher/${this.configuration.encodeParam({name: "codice", value: codice, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/articoli`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<VoucherArticoloRigaBackofficeDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elenca i negozi che hanno transato sul bando (tendina del filtro).
     * Voci della tendina \&#39;negozio\&#39; nel filtro della lista transazioni: solo i negozi che hanno EFFETTIVAMENTE transato sul bando, non tutti quelli abilitati (una tendina che offre opzioni da cui non esce nessuna riga fa sembrare rotto il filtro). Include i negozi con sole righe annullate: quelle righe restano in lista, ed e\&#39; proprio chi cerca una correzione ad averne bisogno. Stesso gate e stesso scope della lista (checkTipoPratica: SUPERADMIN bypassa, OP_COMUNE fuori-comune -&gt; 403). Non paginato.
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/transazioni/negozi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listNegoziTransazioniBackoffice(requestParameters: ListNegoziTransazioniBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<NegozioTransazioniSelectDTO>>;
    public listNegoziTransazioniBackoffice(requestParameters: ListNegoziTransazioniBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<NegozioTransazioniSelectDTO>>>;
    public listNegoziTransazioniBackoffice(requestParameters: ListNegoziTransazioniBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<NegozioTransazioniSelectDTO>>>;
    public listNegoziTransazioniBackoffice(requestParameters: ListNegoziTransazioniBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listNegoziTransazioniBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/transazioni/negozi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<NegozioTransazioniSelectDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elenca le transazioni voucher di un bando (input dell\&#39;errata-corrige).
     * Page delle transazioni del bando (scope per-comune via checkTipoPratica: SUPERADMIN bypassa, OP_COMUNE fuori-comune → 403), filtrabile per id_pratica e/o codice_voucher. Ogni riga porta id_transazione, codice_voucher, intestatario, nome_negozio e version_voucher — quest\&#39;ultima da rispedire nel form errata-corrige senza un GET di dettaglio aggiuntivo. Ordinamento default per data DESC.
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/transazioni
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTransazioniBackoffice(requestParameters: ListTransazioniBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTransazioneVoucherBackofficeListItemDTO>;
    public listTransazioniBackoffice(requestParameters: ListTransazioniBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTransazioneVoucherBackofficeListItemDTO>>;
    public listTransazioniBackoffice(requestParameters: ListTransazioniBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTransazioneVoucherBackofficeListItemDTO>>;
    public listTransazioniBackoffice(requestParameters: ListTransazioniBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listTransazioniBackoffice.');
        }
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listTransazioniBackoffice.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listTransazioniBackoffice.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/transazioni`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTransazioneVoucherBackofficeListItemDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
